import React, { Component } from 'react';
import { LineChecker } from '../classes/LineChecker';
import { FeedBackVo } from '../classes/dataObjects/FeedBackVo';
import EmojiPanel from './EmojiPanel';
interface MyProps { }
interface MyState { text: string, pfeedback: string[], nfeedback: string[], score: number, letterGrade: string,panelIndex:number }
class MyClass extends Component<MyProps, MyState> {
    constructor(props: MyProps) {
        super(props);
        this.state = {
            text: "", pfeedback: [], nfeedback: [], score: 0, letterGrade: '', panelIndex: 0
        };
    }
    onChangeText(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ text: e.target.value });
    }
    onClickButton() {
        const lineChecker: LineChecker = new LineChecker();
        let feedBackVo: FeedBackVo = lineChecker.checkLine(this.state.text);
        this.setState({pfeedback:feedBackVo.posFeedback, nfeedback: feedBackVo.negFeedback, score: feedBackVo.score, letterGrade: feedBackVo.letterGrade });
    }
    getFeedback(list: string[]) {
        if (list.length === 0) {
            return null;
        }


        let feedbackList: JSX.Element[] = [];
        for (let i = 0; i < list.length; i++) {
            feedbackList.push(<li key={i}>{list[i]}</li>);
        }
        return (<ul className='feedbacklist'>{feedbackList}</ul>);
    }
    addEmoji(emoji: string) {
        this.setState({ text: this.state.text + emoji });
    }
    getFeedBackPanel() {
        if (this.state.pfeedback.length === 0 && this.state.nfeedback.length === 0) {
            return <div className='panel'>No feedback available</div>;
        }
        return (<div className='panel'>
            <div>Score: {this.state.score}</div>
            <div className='feedbackPos'>{this.getFeedback(this.state.pfeedback)}</div>
            <div className='feedbackNeg'>{this.getFeedback(this.state.nfeedback)}</div>
        </div>);
    }
    getPanel()
    {
        switch(this.state.panelIndex) {
            case 0:
                return this.getFeedBackPanel();
            case 1:
                return <EmojiPanel callback={this.addEmoji} />;
           
            case 2:
                return <div>Panel 2</div>;
            default:
                return <div>No panel found</div>;
        }
    }
    getTabButtons() {
        let tabButtons: JSX.Element[] = [];
        let tabNames: string[] = ["Feedback", "Emoji", "Panel 2"];
        for (let i = 0; i < tabNames.length; i++) {
            let tabName = tabNames[i];
            let tabKey = "tabKey" + i;
            tabButtons.push(<button key={tabKey} className='tabButton' onClick={() => this.setState({ panelIndex: i })}>{tabName}</button>);
        }
        //return the tab buttons
        //return (<div className='tabButtons'>{tabButtons}</div>);
        return (<div className='tabButtons'>{tabButtons}</div>);
    }
    render() {
        
        return (<div>
            <div className='letterGrade'>{this.state.letterGrade}</div>
           
            <input type="text" value={this.state.text} onChange={(e) => this.onChangeText(e)} placeholder="Enter Your Email Subject Line" />
            
            <button onClick={() => this.onClickButton()}>Check</button>
           {this.getFeedback(this.state.pfeedback)}
            {this.getFeedback(this.state.nfeedback)}
        </div>);
    }
}
export default MyClass;